//=====================================================
//　入力項目ラベル(ヘルプテキスト付)
//=====================================================
import { useState } from 'react';
import { InputTag } from "../utils/ConstCommon";

interface IFProps {
    title: string,
    tag?: InputTag,
    message?: string,
}

export function LblInputHelper(props: IFProps){

    const [cln, setCln] = useState("input-title-help-message text-s is-hidden");
    function onMouseOver () {
        setCln("input-title-help-message text-s show");
    }
    function onMouseOut () {
        setCln("input-title-help-message text-s is-hidden");
    }

    return (
        <div className="input-title">
            <label htmlFor="name">{props.title}</label>
            <span className="icon-help" onMouseOver={onMouseOver} onMouseOut={onMouseOut}></span>
            <div className={cln} style={{whiteSpace: 'pre-line'}}>
                {props.message}
            </div>
            {props.tag === InputTag.Required && <span className="tag input-tag tag-red">必須</span>}
            {props.tag === InputTag.Optional && <span className="tag input-tag tag-gray">任意</span>}
        </div>
    )

}